import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useFeatureFlags } from '../../../infra/feature-flags';
import { OnboardingCtaBanner } from './onboarding-cta-banner';
export var OnboardingCtaBannerContainer = function (props) {
    var showShopOnboarding = useFeatureFlags().shopOnboarding;
    useEffect(function () {
        if (showShopOnboarding) {
            var maintenanceBarHeight = getComputedStyle(document.documentElement).getPropertyValue('--onboarding-cta-bar-expanded-height');
            document.documentElement.style.setProperty('--onboarding-cta-bar-height', maintenanceBarHeight);
        }
        else {
            document.documentElement.style.setProperty('--onboarding-cta-bar-height', '0px');
        }
    }, [showShopOnboarding]);
    useEffect(function () {
        return function () {
            document.documentElement.style.setProperty('--onboarding-cta-bar-height', '0px');
        };
    }, []);
    if (!showShopOnboarding) {
        return null;
    }
    return _jsx(OnboardingCtaBanner, { onClick: props.onClick });
};
